import styles from './SunSpinner.module.scss';

export function SunSpinner({ rays = 12 }: { rays?: number }) {
  return (
    <div
      className={styles.sunSpinner}
      role="status"
      aria-label="Loading"
      data-testid="loader"
    >
      <span className={styles.core} />
      <span className={styles.rays} aria-hidden="true">
        {Array.from({ length: rays }).map((_, i) => (
          <span
            key={i}
            className={styles.ray}
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            style={{ ['--rot' as any]: `${(i * 360) / rays}deg` }}
          />
        ))}
      </span>
    </div>
  );
}
